import APIV5 from '~/models/api';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import { UserModel } from '~/scripts/services/model/user';

export default class AccountWorkflowController {
	/* @ngInject */
	/**
	 * @param {any} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {UserModel} User
	 */
	constructor($rootScope, $timeout, User) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.User = User;

		this.delegation = {
			period:               {
				begin: null,
				end:   null,
			},
			wfallocator_from_kid: User.getProfil().kid,
			wfallocator_to_kid:   undefined,
		};
		this.delegationFilter = {
			previous: false,
			current:  true,
			next:     true,
		};

		/** @type {any[]} */
		this.delegationList = [];

		this.delegationListDuration = 0;
		this.delegationListNb = 0;
		this.formDelegation = undefined;
		this.notificationLoading = false;

		/** @type {any} */
		this.notification = {
			workflow: {
				kid:    undefined,
				enable: false,
			},
		};

		/** @type {any} */
		this.subscription = undefined;

		/** @type {any[]} */
		this.subscriptions = [];

		if (this.$rootScope.context && this.$rootScope.context.profil) {
			(async () => {
				await this.loadSubscriptionList();
				await this.getWorkflowNotification();
				await this.delegateList();
			})()
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {Promise<any>}
	 */
	async delegateDel(kid) {
		await APIV5.instance.wfDelegateDel({ wfdelegate_kid: kid }, { id: 'account-workflow.delegate-del' });
		return this.delegateList();
	}

	async delegateList() {
		const result = await APIV5.instance.wfDelegateList({}, { id: 'account-workflow.delegate-list' });
		this.$timeout(() => {
			this.delegationList.length = 0;
			// @ts-ignore
			this.delegationListDuration = result._et_ * 1000;
			this.delegationListNb = result.nb;
			for (const delegationItem of result.list) {
				// @ts-ignore
				delegationItem.date_begin.sdate = delegationItem.date_begin.kid === 'K_NODE;INFINITEM'
					? Number.NEGATIVE_INFINITY : new Date(delegationItem.date_begin.sdate);

				// @ts-ignore
				delegationItem.date_end.sdate = delegationItem.date_end.kid === 'K_NODE;INFINITEP'
					? Number.POSITIVE_INFINITY : new Date(delegationItem.date_end.sdate);

				this.delegationList.push({ ...delegationItem });
			}
		});
	}

	async delegateSet() {
		if (this.delegation.wfallocator_to_kid !== undefined) {
			// @ts-ignore
			await APIV5.instance.wfDelegateSet(this.delegation);
			this.delegation.period.begin = null;
			this.delegation.period.end = null;
			this.delegation.wfallocator_from_kid = this.User.getProfil().kid;
			this.delegation.wfallocator_to_kid = undefined;
		}
		return this.delegateList();
	}

	filterByDate() {
		return (/** @type {any} */ value) => {
			const now = new Date();
			return (this.delegationFilter.previous && value.date_end.sdate < now)
				|| (this.delegationFilter.current && value.date_begin.sdate <= now && value.date_end.sdate > now)
				|| (this.delegationFilter.next && value.date_begin.sdate > now);
		};
	}

	/**
	 * @param {any} dateBegin
	 * @param {any} dateEnd
	 * @returns {{'text-warning': boolean, 'text-success': boolean, 'text-info': boolean}}
	 */
	getClassDate(dateBegin, dateEnd) {
		const now = new Date();
		return {
			'text-warning': dateEnd.sdate < now,
			'text-success': dateBegin.sdate <= now && dateEnd.sdate > now,
			'text-info': dateBegin.sdate > now,
		};
	}

	async getWorkflowNotification() {
		this.notificationLoading = true;
		const result = await APIV5.instance.queryExec({
			query: {
				select: [
					{
						kid:               'K_NODE;WF_NOTIFICATION',
						node:              'KID',
						op:                'detail',
						path:              [{
							kid:        'K_NODE;WF_NOTIFICATION',
							linker_kid: '0',
						}],
						type:              'K_NODE;STRING',
					},
					{
						kid:  'K_NODE;BOOL',
						node: 'KID',
						op:   'detail',
						path: [
							{
								kid:  'K_NODE;WF_NOTIFICATION',
								flow: null,
							},
							{
								kid:        'K_NODE;BOOL',
								flow:       'down',
								linker_kid: 'K_NODE;EMAIL',
							},
						],
						type: 'K_NODE;STRING',
					},
				],
				from:   [
					{
						node: 'K_NODE;WF_NOTIFICATION',
						type: 'K_NODE;STRING',
					},
				],
				where:  {
					condition: 'AND',
					rules:     [
						{
							condition: 'NONE',
							field:     'K_NODE;KPROFIL',
							// having: null,
							id:         'K_NODE;KPROFIL',
							operator:   'equal_kid',
							path:       [
								{
									kid:  'K_NODE;WF_NOTIFICATION',
									flow: null,
								},
								{
									kid:        'K_NODE;KPROFIL',
									flow:       'down',
									linker_kid: '0',
								},
							],
							type:       'K_NODE;STRING',
							value:      [
								{
									kid: this.$rootScope.context.profil.kid,
								},
							],
							linker_kid: '0',
						},
					],
				},
			},
		});
		this.$timeout(() => {
			this.notificationLoading = false;
			if (result.result?.rows?.length > 0) {
				const row = result.result?.rows[0];
				this.notification.workflow.kid = row[0][0].kid;
				this.notification.workflow.enable = row[1][0].kid === 'K_NODE;TRUE';
			}
		});
	}


	isAdmin() {
		return this.$rootScope.context?.profil.admin;
	}

	async loadSubscriptionList() {
		this.subscriptions.length = 0;
		const result = await APIV5.instance.wfSubscriptionList({
			profil_kid: this.$rootScope.context.profil.kid,
		});

		if (result?.list) {
			for (const subscription of result.list) {
				this.subscriptions.push(subscription);
			}
		}
	}

	async setWorkflowNotification() {
		let create = false;

		if (!this.notification.workflow.kid) {
			this.notification.workflow.kid = `K_NODE;${this.User.getRef()}`;
			create = true;
		}
		const composedOf = [
			{
				objnum2:    this.notification.workflow.enable ? 'K_NODE;TRUE' : 'K_NODE;FALSE',
				class_kid:  'K_NODE;BOOL',
				linker_kid: 'K_NODE;EMAIL',
			},
		];

		if (create) {
			composedOf.push({
				objnum2:    this.$rootScope.context.profil.kid,
				class_kid:  'K_NODE;KPROFIL',
				linker_kid: '0',
			});
		}

		this.notificationLoading = true;
		try {
			await APIV5.instance.objectSet({
				items: [
					{
						target_objnum: this.notification.workflow.kid,
						OBJECT_LIST:   {
							[this.notification.workflow.kid]: {
								isa:       'K_NODE;WF_NOTIFICATION',
								LINK_LIST: {
									[COMPOSED_OF]: composedOf,
								},
							},
						},
					},
				],
			}, { id: 'account.workflow.set-workflow-notification' });
		}
		catch (error) {
			console.error(error);
		}
		await this.getWorkflowNotification();
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} objnum
	 */
	async subscriptionSet(objnum) {
		await APIV5.instance.wfSubscriptionSet({ objnum });
		await this.loadSubscriptionList();
		this.subscription = undefined;
	}

	/**
	 * @param {{ kid: import('@knitiv/api-client-javascript').KNode; }} subscription
	 */
	async subscriptionDel(subscription) {
		try {
			await APIV5.instance.wfSubscriptionDel({
				wfsubscription_kid: subscription.kid,
			});
			return this.loadSubscriptionList();
		}
		catch (error) {
			console.error(error);
		}
		return false;
	}
}
